export default __webpack_public_path__ + "static/Appstore-4a4a5fd61e2eb77efbf6151dd48ce7c1.png";